/**
 * @typedef {import('./lib/react-markdown.js').ReactMarkdownOptions} Options
 * @typedef {import('./lib/ast-to-react.js').Components} Components
 */

export {uriTransformer} from './lib/uri-transformer.js'

export {ReactMarkdown as default} from './lib/react-markdown.js'
